const uploadBtnRenderType = Object.freeze({
  UploadDataTable: "UploadDataTable",
  CandidateDetail: "CandidateDetail",
  Search: "Search"
});

export default uploadBtnRenderType;